
import { defineComponent, inject } from 'vue'
import LoadingPulse from '@/components/shared/LoadingPulse.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import Toaster from '@meforma/vue-toaster'
import { DashboardInformationService } from '@/services/dashboardInformation.service'
import { DashboardInformationDetails } from '@/@types/responses/dashboard_information/DashboardInformationDetails'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'
import NoteTile from '@/components/elements/NoteTile.vue'
import { Note } from '@/@types/responses/note/Note'
import { NoteService } from '@/services/note.service'
import NoteModal from '@/components/modals/NoteModal.vue'

export default defineComponent({
  name: 'Dashboard',
  components: {
    LoadingPulse,
    NoteModal,
    NoteTile
  },
  beforeRouteLeave() {
    if (this.note) {
      this.note = undefined
      return false
    }

    return true
  },
  setup() {
    const dashboardInformationService = inject(PROVIDER_CONSTANTS.dashboardInformationService) as DashboardInformationService
    const noteService = inject(PROVIDER_CONSTANTS.noteService) as NoteService
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster

   return {
      dashboardInformationService,
      noteService,
      toast
    }
  },
  data() {
    let note: Note|undefined

    return {
      dashboardInformation: new DashboardInformationDetails({ buildSteps: [], customerApprovedQuotes: [], purchaseOrders: [] }),
      loading: true,
      note,
      noteOrderId: 0
    }
  },
  mounted() {
    this.getDashboardInformation()
  },
  methods: {
    countClass(count: number): string {
      if (count < 5) return 'good'
      else if (count < 10) return 'warn'

      return 'bad'
    },
    getDashboardInformation(): Promise<void> {
      return this.dashboardInformationService.getDashboardInformation().then(dashboardInformation => {
        this.dashboardInformation = dashboardInformation
        this.loading = false
      }).catch(error => {
        if (error instanceof ErrorsResponse) {
          const errorsResponse = error as ErrorsResponse

          if (errorsResponse.errors.some(e => e.id === 33001 || e.id === 33002 || e.id === 33003)) return

          this.toast.error(errorsResponse.errors.map(e => e.message).join("\r\n"))
        } else {
          this.toast.error('Failed to load the dashboard information. Try reloading the page.')
        }
      })
    },
    onAddNoteClicked(orderId: number): void {
      this.noteOrderId = orderId
      this.note = new Note(0)
    },
    onDeleteNote(note: Note): void {
      this.noteService.deleteNote(note.id).then(() => {
        this.getDashboardInformation().then(() => {
          this.toast.success('The note was deleted successfully.')
        })
      }).catch(error => {
        if (error instanceof ErrorsResponse) {
          const errorsResponse = error as ErrorsResponse

          if (errorsResponse.errors.some(e => e.id === 33001 || e.id === 33002 || e.id === 33003)) return

          this.toast.error(errorsResponse.errors.map(e => e.message).join("\r\n"))
        } else {
          this.toast.error('Failed to delete the note. Please try again.')
        }
      })
    },
    onEditNoteClicked(note: Note, orderId: number): void {
      this.noteOrderId = orderId
      this.note = note
    },
    onOrderClicked(id: number): void {
      this.$router.push('/order/' + id)
    },
    onQuoteClicked(id: number): void {
      this.$router.push('/quote/' + id)
    }
  }
})
